import { Box } from "@mui/material";
import withClearCache from "ClearCache";
import viewpaths from "global/constants/ViewPathConstants";
import "index.css";
import DrawerLayout from "layouts/DrawerLayout/DrawerLayout";
import { Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AdminProtectedRoute from "screens/Admin/components/AdminProtectedRoute/AdminProtectedRoute";
import AdminAnalyticsPage from "screens/Admin/AdminAnalyticsPage";
import AdminBlogsPage from "screens/Admin/AdminBlogsPage";
import AdminDashboard from "screens/Admin/AdminDashboard";
import AdminProfilePage from "screens/Admin/AdminProfilePage";
import BlogEditPage from "screens/Admin/components/BlogEditPage/BlogEditPage";
import Login from "screens/Auth/login";
import Blogs from "screens/Blogs/Blogs";
import BlogDetail from "screens/Blogs/components/BlogDetail";
import Contact from "screens/Contact/Contact";
import Home from "screens/Home/Home";
import PageNotFound from "screens/PageNotFound/PageNotFound";
import PrivacyPolicy from "screens/PrivacyPolicy/PrivacyPolicy";
import ScrollToTop from "utils/ScrollToTop";
import Notifications from "utils/notifications";
import "./i18n";

const App = () => {
  return <ClearCacheComponent />;
};

const MainApp = () => {
  return (
    <Box>
      <Suspense fallback={null}>
        <BrowserRouter>
          <ScrollToTop />
          <Switch>
            <Route>
              <DrawerLayout>
                <Switch>
                  <Route exact path={viewpaths.landingViewPath} component={Home} />
                  <Route exact path={viewpaths.loginViewPath} component={Login} />
                  <Route exact path={viewpaths.blogsViewPath} component={Blogs} />
                  <Route
                    exact
                    path={viewpaths.blogDetailViewPath}
                    component={BlogDetail}
                  />
                  <Route
                    exact
                    path={viewpaths.contactViewPath}
                    component={Contact}
                  />
                  <Route
                    exact
                    path={viewpaths.privacyPolicyViewPath}
                    component={PrivacyPolicy}
                  />
                  <Route path={viewpaths.adminDashboardViewPath}>
                    <AdminProtectedRoute>
                      <Switch>
                        <Route
                          exact
                          path={viewpaths.adminDashboardViewPath}
                          component={AdminDashboard}
                        />
                        <Route
                          exact
                          path={viewpaths.adminAnalyticsViewPath}
                          component={AdminAnalyticsPage}
                        />
                        <Route
                          exact
                          path={viewpaths.adminBlogsViewPath}
                          component={AdminBlogsPage}
                        />
                        <Route
                          exact
                          path={viewpaths.adminProfileViewPath}
                          component={AdminProfilePage}
                        />
                        <Route
                          exact
                          path={viewpaths.adminBlogEditViewPath}
                          component={BlogEditPage}
                        />
                      </Switch>
                    </AdminProtectedRoute>
                  </Route>
                  <Route path={""} component={PageNotFound} />
                </Switch>
              </DrawerLayout>
            </Route>
          </Switch>
          <Notifications />
        </BrowserRouter>
      </Suspense>
    </Box>
  );
};

const ClearCacheComponent = withClearCache(MainApp);

export default App;
